import { useState } from "react"

const useCounter = (initCount: any = 0) => {
  const [count, setCount] = useState(initCount)
  return [count, setCount]
}

export { useCounter }
